// extracted by mini-css-extract-plugin
module.exports = {"loadingStateContainer":"az_P3c","rating":"az_Q3c","title":"az_R3c","postDetails":"az_S3c","content":"az_T3c","images":"az_U3c","purchasedFor":"az_V3c","feedbackButtons":"az_W3c"};